import * as runtime from '@/api/runtime'
import {
  BatchUserListRequest,
  BatchUserListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchUserListCondition,
  BatchUserListConditionFromJSON
} from '@/api/models/batch/BatchUserListCondition'

/**
 * 帳票作成
 */
export class BatchUserListApi extends runtime.BaseAPI {
  async return(request: BatchUserListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/user-management/user-list`,
      BatchUserListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchUserListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchUserListConditionFromJSON(jsonValue)
    ).value()
  }
}
